import { render, staticRenderFns } from "./TaskResourceAssignments.vue?vue&type=template&id=0dbca914&scoped=true&"
import script from "./TaskResourceAssignments.vue?vue&type=script&lang=js&"
export * from "./TaskResourceAssignments.vue?vue&type=script&lang=js&"
import style0 from "./TaskResourceAssignments.vue?vue&type=style&index=0&id=0dbca914&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dbca914",
  null
  
)

export default component.exports